import ModalAutoT from "_+_Portal/_-_Autocheckin/components/genericos/ModalAutoT/ModalAutoT";


const TiempoExtra = ({ aceptar, cancelar }) => {
  return (
    <ModalAutoT
      title={"Tiempo Extra"}
      desc={
        "Si necesita mas tiempo para pagar correctamente por Mercado Pago oprima si"
      }
      textBtnOne={"SI"}
      textBtnTwo={"NO"}
      handleChange={{
        btnTwo: cancelar,
        btnOne: aceptar,
      }}
    />
  );
};

export default TiempoExtra;
